import Failure from "./Failure"

function FailureModal({ message }) {
    return (
        <div id="modal-error" className="modal">
            <div className="modal-background"></div>
            <div className="modal-card">
                <header className="modal-card-head has-text-centered">
                    <p className="modal-card-title">Something went wrong</p>
                    <button className="delete" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}></button>
                </header>
                <section className="modal-card-body">
                    <Failure message={message} isNotFullHeight={true} />
                </section>
                <footer className="modal-card-foot">
                    <button className="button" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}>Close</button>
                </footer>
            </div>
        </div>
    )
}

export default FailureModal;